import { render, staticRenderFns } from "./asideNav.vue?vue&type=template&id=0b5a0d13&scoped=true&"
import script from "./asideNav.vue?vue&type=script&lang=js&"
export * from "./asideNav.vue?vue&type=script&lang=js&"
import style0 from "./asideNav.vue?vue&type=style&index=0&id=0b5a0d13&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5a0d13",
  null
  
)

export default component.exports